import {
  FETCH_SUPPORT_REQUESTS,
  FETCH_SUPPORT_REQUESTS_SUCCESS,
  FETCH_SUPPORT_REQUESTS_FAILED,
  EDIT_SUPPORT_REQUEST,
  FETCH_SUPPORT_CATEGORIES,
  FETCH_SUPPORT_CATEGORIES_SUCCESS,
  FETCH_SUPPORT_CATEGORIES_FAILED,
  EDIT_SUPPORT_CATEGORY
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove, update, ref, query, orderByChild } from "firebase/database";

// Fetch support requests
export const fetchSupportRequests = () => (dispatch) => {
  console.log('🚀 fetchSupportRequests called');
  console.log('🔍 Firebase object:', firebase);
  
  if (!firebase) {
    console.error('❌ Firebase not initialized');
    dispatch({
      type: FETCH_SUPPORT_REQUESTS_FAILED,
      payload: "Firebase not initialized",
    });
    return;
  }
  
  const { supportRequestsRef } = firebase;
  console.log('📋 supportRequestsRef function:', supportRequestsRef);
  
  if (!supportRequestsRef) {
    console.error('❌ supportRequestsRef not available');
    dispatch({
      type: FETCH_SUPPORT_REQUESTS_FAILED,
      payload: "supportRequestsRef not available",
    });
    return;
  }
  
  console.log('📡 Dispatching FETCH_SUPPORT_REQUESTS...');
  dispatch({
    type: FETCH_SUPPORT_REQUESTS,
    payload: null,
  });

  try {
    const refInstance = supportRequestsRef();
    console.log('📍 Reference instance:', refInstance);
    
    onValue(refInstance, (snapshot) => {
      console.log('📨 Support requests snapshot received:', snapshot.val());
      console.log('📊 Snapshot exists:', snapshot.exists());
      
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .map((i) => {
            data[i].id = i;
            return data[i];
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        
        console.log('✅ Support requests processed:', arr);
        dispatch({
          type: FETCH_SUPPORT_REQUESTS_SUCCESS,
          payload: arr,
        });
      } else {
        console.log('📭 No support requests found');
        dispatch({
          type: FETCH_SUPPORT_REQUESTS_FAILED,
          payload: "No support requests found",
        });
      }
    }, (error) => {
      console.error('❌ Firebase onValue error:', error);
      dispatch({
        type: FETCH_SUPPORT_REQUESTS_FAILED,
        payload: error.message,
      });
    });
  } catch (error) {
    console.error('❌ Error setting up listener:', error);
    dispatch({
      type: FETCH_SUPPORT_REQUESTS_FAILED,
      payload: error.message,
    });
  }
};

// Edit support request (update status, add admin notes, etc.)
export const editSupportRequest = (supportRequest, method) => (dispatch) => {
  const { supportRequestsRef, supportRequestEditRef } = firebase;
  
  dispatch({
    type: EDIT_SUPPORT_REQUEST,
    payload: { method, supportRequest }
  });

  if (method === 'Delete') {
    remove(supportRequestEditRef(supportRequest.id));
  } else if (method === 'UpdateStatus') {
    const updateData = {
      ...supportRequest,
      status: supportRequest.status,
      adminNotes: supportRequest.adminNotes || '',
      updatedAt: new Date().getTime(),
      updatedBy: supportRequest.updatedBy || ''
    };
    set(supportRequestEditRef(supportRequest.id), updateData);
  } else {
    set(supportRequestEditRef(supportRequest.id), supportRequest);
  }
};

// Fetch support categories
export const fetchSupportCategories = () => (dispatch) => {
  const { supportCategoriesRef } = firebase;
  
  dispatch({
    type: FETCH_SUPPORT_CATEGORIES,
    payload: null,
  });

  onValue(supportCategoriesRef(), (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data)
        .map((i) => {
          data[i].id = i;
          return data[i];
        })
        .sort((a, b) => a.name?.localeCompare(b.name));
      
      dispatch({
        type: FETCH_SUPPORT_CATEGORIES_SUCCESS,
        payload: arr,
      });
    } else {
      // Set default categories if none exist
      const defaultCategories = [
        {
          name: 'Payment Issues',
          description: 'Problems with payments, billing, or wallet',
          active: true
        },
        {
          name: 'Trip Problems',
          description: 'Issues during or after a trip',
          active: true
        },
        {
          name: 'App Technical Issues',
          description: 'App crashes, login problems, or bugs',
          active: true
        },
        {
          name: 'Account Issues',
          description: 'Profile, settings, or account access problems',
          active: true
        },
        {
          name: 'Safety Concerns',
          description: 'Report safety issues or incidents',
          active: true
        },
        {
          name: 'Other Issues',
          description: 'Any other questions or concerns',
          active: true
        }
      ];

      // Create default categories
      defaultCategories.forEach(category => {
        push(supportCategoriesRef(), category);
      });

      dispatch({
        type: FETCH_SUPPORT_CATEGORIES_SUCCESS,
        payload: defaultCategories,
      });
    }
  });
};

// Edit support category
export const editSupportCategory = (category, method) => async (dispatch) => {
  const { supportCategoriesRef, supportCategoryEditRef } = firebase;
  
  dispatch({
    type: EDIT_SUPPORT_CATEGORY,
    payload: { method, category }
  });

  try {
    if (method === 'Add') {
      await push(supportCategoriesRef(), category);
    } else if (method === 'Delete') {
      await remove(supportCategoryEditRef(category.id));
    } else {
      await set(supportCategoryEditRef(category.id), category);
    }
  } catch (error) {
    console.error('Firebase operation error:', error);
    throw error; // Re-throw the error so it can be caught in the component
  }
}; 